import angular from 'angular'
import { utilsModule } from '../utils-module';

var CPF = require("@fnando/cpf/dist/node");
var CNPJ = require("@fnando/cnpj/dist/node");
var cpfCnpj = {
    isValid:function(str){
        if(!str || (str.length == 0)) return true;

        if(str.length == 14){
            return CNPJ.isValid(str);
        }else if(str.length == 11){
            return CPF.isValid(str);
        }else{
          return false
        }
    }
}

utilsModule.directive('cpf', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl:any) {
            var isEmpty = function (value) {
               return angular.isUndefined(value) || value === "" || value === null;
            }

            var cpfValidator = function(value) {
              if (isEmpty(value)){
                ctrl.$setValidity('cpf',true);
                return '';
              }else if(!/^\d+$/.test(value)){//Verifica se possui apenas dígitos
                ctrl.$setValidity('cpf',false);
                return undefined;
              }if (value.length != 11){
                ctrl.$setValidity('cpf',false);
                return undefined;
              } else {
                ctrl.$setValidity('cpf', CPF.isValid(value));
                return value;
              }
            };

            ctrl.$parsers.push(cpfValidator);
            ctrl.$formatters.push(cpfValidator);
        }
    };
});

utilsModule.directive('cnpj', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl:any) {
            var isEmpty = function (value) {
               return angular.isUndefined(value) || value === "" || value === null;
            }

            var cnpjValidator = function(value) {
              if (isEmpty(value)){
                ctrl.$setValidity('cnpj',true);
                return '';
              }else if(!/^\d+$/.test(value)){//Verifica se possui apenas dígitos
                ctrl.$setValidity('cnpj',false);
                return undefined;
              }else if (value.length != 14){
                ctrl.$setValidity('cnpj',false);
                return undefined;
              } else {
                ctrl.$setValidity('cnpj', CNPJ.isValid(value));
                return value;
              }
            };

            ctrl.$parsers.push(cnpjValidator);
            ctrl.$formatters.push(cnpjValidator);
        }
    };
});

utilsModule.directive('cpfCnpj', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl:any) {
            var isEmpty = function (value) {
               return angular.isUndefined(value) || value === "" || value === null;
            }

            var cpfCnpjValidator = function(value) {
              if (isEmpty(value)){
                ctrl.$setValidity('cpfCnpj',true);
                return '';
              }else if(!/^\d+$/.test(value)){//Verifica se possui apenas dígitos
                ctrl.$setValidity('cpfCnpj',false);
                return undefined;
              }else if ((value.length != 11) && (value.length != 14)){
                ctrl.$setValidity('cpfCnpj',false);
                return undefined;
              } else {
                ctrl.$setValidity('cpfCnpj', cpfCnpj.isValid(value));
                return value;
              }
            };

            ctrl.$parsers.push(cpfCnpjValidator);
            ctrl.$formatters.push(cpfCnpjValidator);
        }
    };
});